import { shopifyComponentCopy } from '@testfeed/product-language'
import { HomeArt, useReplay } from '../art/HomeArt'

interface Props {
  /** Label and handler for the hero's button, or null to hide it. */
  cta: { label: string; onClick: () => void } | null
  /** Dismissing is offered once setup is done. Before that the hero is how merchants learn what TestFeed is. */
  onDismiss?: () => void
}

/** Callout card composition: what TestFeed is, shown as an example test. */
export function Hero({ cta, onDismiss }: Props) {
  const copy = shopifyComponentCopy.appHome
  const [replay, again] = useReplay()
  return (
    <s-section accessibilityLabel={copy.heroAriaLabel}>
      <s-grid gridTemplateColumns={onDismiss ? '1fr auto' : '1fr'} gap="small-400" alignItems="start">
        <s-grid gridTemplateColumns="@container (inline-size <= 640px) 1fr, 5fr 9fr" gap="large" alignItems="center">
          <s-stack gap="base">
            <s-heading>{copy.heroTitle}</s-heading>
            <s-paragraph color="subdued">{copy.heroBody}</s-paragraph>
            {cta && (
              <s-stack direction="inline" gap="small-200">
                <s-button onClick={cta.onClick}>{cta.label}</s-button>
              </s-stack>
            )}
          </s-stack>
          <s-stack gap="small-200">
            <s-stack direction="inline" justifyContent="end" alignItems="center">
              <s-button
                variant="tertiary"
                tone="neutral"
                icon="refresh"
                accessibilityLabel={copy.heroReplayAction}
                onClick={again}
              ></s-button>
            </s-stack>
            <HomeArt
              name="hero"
              replay={replay}
              alt="Example: 200 simulated shoppers compare version A and version B. B wins."
              background="transparent"
            />
          </s-stack>
        </s-grid>
        {onDismiss && (
          <s-button
            variant="tertiary"
            tone="neutral"
            icon="x"
            accessibilityLabel={copy.heroDismissAction}
            onClick={onDismiss}
          ></s-button>
        )}
      </s-grid>
    </s-section>
  )
}
